import {invoiceConstants} from '../constants';

const invoiceState = {
  invoicesListUrl: undefined,
  invoicesListQuery: undefined
};

const invoiceReducer = (state = invoiceState, action) => {
  const {type} = action;
  switch (type) {
    case invoiceConstants.SAVE_INVOICES_LIST_URL:
      return {
        ...state,
        invoicesListUrl: action?.payload?.url,
        invoicesListQuery: action?.payload?.query
      }
    default:
      return state
  }
};

export default invoiceReducer;
